import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ConstructionBanner from './ConstructionBanner';
import InfoBanner from './InfoBanner';
import WelcomePopup from './WelcomePopup';

const Layout: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <WelcomePopup />
      <InfoBanner />
      <ConstructionBanner />
      <main className="flex-grow pt-16 pb-24 md:pb-32">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;